<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="16" height="16" viewBox="0 0 16 16" fill="none">                
    <path d="M5.33331 2.66671L10.5595 7.74878C10.7024 7.88747 10.7024 8.11261 10.5595 8.2513L5.33331 13.3334" stroke="#737373" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
